import React, { useState, useMemo, useEffect } from 'react';
import cx from 'classnames';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import bg from './image/bg.png.js';
import styles from './index.module.scss.js';

const RewardsSliderPreview = ({
  className,
  style,
  monthRange,
  weekRange,
  activeTabIndex = 0,
  onTabChange = () => {
  },
  texts = {
    lossback: "Lossback",
    rackeback: "Rackeback",
    monthBtn: "Monthly",
    weekBtn: "Weekly",
    title: "Your rewards slider",
    lockTitle: "Feature locked",
    lockWeekSubTitle: "Earn more XP and reach level \u2018Silver 1\u2019 to unlock the Rewards Slider.",
    lockMonthSubTitle: "Earn more XP and reach level \u2018Gold 1\u2019 to unlock the Rewards Slider."
  },
  ...props
}) => {
  const [idx, setIdx] = useState(activeTabIndex);
  const data = useMemo(
    () => ({
      rackeback: idx === 0 ? weekRange.rakeback : monthRange.rakeback,
      lossback: idx === 0 ? weekRange.lossback : monthRange.lossback
    }),
    [idx, weekRange, monthRange]
  );
  const isShowLock = useMemo(
    () => idx === 0 && weekRange.isLocked || idx === 1 && monthRange.isLocked,
    [idx, weekRange, monthRange]
  );
  const lockText = useMemo(
    () => ({
      title: texts.lockTitle,
      subtitle: idx === 0 ? texts.lockWeekSubTitle : texts.lockMonthSubTitle
    }),
    [idx, texts]
  );
  useEffect(() => {
    setIdx(activeTabIndex);
  }, [activeTabIndex]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, "rewards-slider-preview"),
      style,
      ...props
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.tabs }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: cx(styles.tabs__tab, {
          [styles.active]: idx === 0
        }),
        type: "button",
        onClick: () => {
          onTabChange(0);
          setIdx(0);
        }
      },
      texts.weekBtn
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: cx(styles.tabs__tab, {
          [styles.active]: idx === 1
        }),
        type: "button",
        onClick: () => {
          onTabChange(1);
          setIdx(1);
        }
      },
      texts.monthBtn
    )),
    /* @__PURE__ */ React.createElement("div", { className: styles.panels }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.panel, "rewards-slider-preview__panel", {
          [styles.locked]: isShowLock
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: cx(styles.title) }, texts.title),
      /* @__PURE__ */ React.createElement("div", { className: cx(styles.values) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.rakeback) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.value) }, data.rackeback, "%"), /* @__PURE__ */ React.createElement("div", { className: cx(styles.text) }, texts.rackeback)), /* @__PURE__ */ React.createElement("div", { className: cx(styles.divider) }), /* @__PURE__ */ React.createElement("div", { className: cx(styles.lossback) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.value) }, data.lossback, "%"), /* @__PURE__ */ React.createElement("div", { className: cx(styles.text) }, texts.lossback))),
      /* @__PURE__ */ React.createElement("img", { className: cx(styles["styled-bg"]), src: bg, alt: "" }),
      isShowLock && /* @__PURE__ */ React.createElement("div", { className: styles.lock }, /* @__PURE__ */ React.createElement("div", { className: styles.lock__title }, /* @__PURE__ */ React.createElement(Icon, { iconName: "LockV2" }), lockText.title), /* @__PURE__ */ React.createElement("div", { className: styles.lock__subtitle }, lockText.subtitle))
    ))
  );
};
RewardsSliderPreview.displayName = "RewardsSliderPreview";

export { RewardsSliderPreview };
//# sourceMappingURL=index.js.map
